import {FoundLocationSchema}from'./found-location.js';import {z}from'zod';const n=z.array(FoundLocationSchema);export{n as FoundLocationResponseSchema};